import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import useClickId from '@/hooks/useClickId'

const useMediaReturn = () => {
  const route = useRoute()
  const store = useStore()
  const commonDsl = computed(() => store.state.dslData.commonDsl)
  const userInfo = computed(() => store.state.userInfo)
  const publicOfficialInfo = computed(() => store.state.publicOfficialInfo)
  const { bid, clickId, notifyType } = useClickId()
  const { query } = route

  // uc回传
  const ucChannel = async (eventType) => {
    let params = {
      clickId: clickId.value,
      link: window.location.href,
      phone: '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      channel: query.channel || commonDsl.value?.channel || '',
      eventType,
      groupId: query.bid || commonDsl.value?.bid || '',
      adPlanId: query.adid || '',
      creativityId: query.creativeid || '',
      creativityType: query.creativetype || '',
    }
    await store.dispatch('fetchUcMediaReturn', params)
  }

  // 百度回传
  const baiduChannel = async (eventType) => {
    const params = {
      clickId: clickId.value,
      token: query.token || commonDsl.value?.token || '',
      link: window.location.href,
      groupId: query.bid || commonDsl.value?.bid || '',
      phone: '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      channel: query.channel || commonDsl.value?.channel || '',
      eventType,
    }
    await store.dispatch('fetchBaiduMediaReturn', params)
  }

  // MP回传
  const wxChannel = async (eventType) => {
    let params = {
      unionId: userInfo.value.unionid || '',
      clickId: clickId.value,
      userActionSetId:
        query.userActionSetId ||
        commonDsl.value?.userActionSetId ||
        '',
      url: window.location.href,
      groupId: query.bid || commonDsl.value?.bid || '',
      phone: '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      eventType,
      // openId: openId || '',
      // appId: getStorage('appId') || '',
      channel: query.channel || commonDsl.value?.channel || '',
    }
    await store.dispatch('fetchMpMediaReturn', params)
  }

  // 广点通回传
  const gdtChannel = async (eventType) => {
    let params = {
      clickId: clickId.value,
      userActionSetId:
        query.userActionSetId ||
        commonDsl.value?.userActionSetId ||
        '',
      url: window.location.href,
      groupId: query.bid || commonDsl.value?.bid || '',
      phone: '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      eventType,
      channel: query.channel || commonDsl.value?.channel || '',
    }
    await store.dispatch('fetchGdtMediaReturn', params)
  }

  // 头条回传
  const toutiaoChannel = async (eventType) => {
    let params = {
      clickId: clickId.value,
      token: query.token || commonDsl.value?.token || '',
      link: window.location.href,
      groupId: query.bid || commonDsl.value?.bid || '',
      phone: '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      eventType,
      channel: query.channel || commonDsl.value?.channel || '',
    }
    await store.dispatch('fetchToutiaoMediaReturn', params)
  }

  // 360PC渠道
  const pc360Channel = async (eventType) => {
    let params = {
      clickId: clickId.value,
      link: window.location.href,
      groupId: query.bid || commonDsl.value?.bid || '',
      phone: '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      eventType,
      channel: query.channel || commonDsl.value?.channel || '',
    }
    await store.dispatch('fetch360MediaReturn', params)
  }

  // 快手渠道
  const kuaishouChannel = async (eventType) => {
    let params = {
      clickId: clickId.value,
      url: window.location.href,
      purchaseAmount: '0.99',
      phone: '',
      groupId: query.bid || commonDsl.value?.bid || '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      eventType,
      channel: query.channel || commonDsl.value?.channel || '',
      adGroupId: '', // 广告组ID
      creativityId: '', //广告创意ID
      adPlanId: '', //广告计划ID
      name: '', // 广告名称
    }
    await store.dispatch('fetchKuaishouMediaReturn', params)
  }
  // 前置加好友回传
  const addFriendFront = async (eventType) => {
    const accountId = query.accountId || commonDsl.value?.accountId || ""
    const channel = query.channel || commonDsl.value?.channel || ""
    if (
      !accountId ||
      !channel ||
      !notifyType.value ||
      (eventType && !eventType.includes("ADD_FRIEND"))
    )
      return;

    const currentNotifyType = notifyType.value;
    const unionId = userInfo.value?.unionid || "";
    const params = {
      accountId,
      channel,
      clickId: clickId.value,
      eventType: "ADD_FRIEND",
      groupId: bid.value,
      link: window.location.href,
      linkType: currentNotifyType === "UC_H5" || currentNotifyType === "BAI_DU_INFO_H5" ? 1 : 0,
      notifyType: currentNotifyType,
      openId: userInfo.value?.openid || "",
      originId: publicOfficialInfo.value?.originId || "",
      unionId,
      wechatAppId: publicOfficialInfo.value?.appId || "",
      sensorsType: 1,
      sensorsContent: {
        public_channel: query.publicChannel || commonDsl.value?.publicChannel || "",
        public_union_id: unionId,
        source: query.source || commonDsl.value?.source || "",
        channel_id: bid.value,
        linkcode: query.linkcode || commonDsl.value?.linkcode || "",
        ad_anonymous_id: query.ad_anonymous_id || commonDsl.value?.ad_anonymous_id || "",
      },
    };

    const userActionSetId =
      query.userActionSetId || commonDsl.value?.userActionSetId || "";
    if (userActionSetId && userActionSetId !== "undefined")
      params.userActionSetId = userActionSetId;

    const token = query.token || commonDsl.value?.token || "";
    if (token && currentNotifyType === "BAI_DU_INFO_H5")
      params.token = decodeURIComponent(token);

    return store.dispatch("fetchAddFriendFront", params);
  };
  // 微博回传
  const weiboChannel = async (eventType) => {
    let params = {
      clickId: 'test',
      link: window.location.href,
      phone: '',
      groupId: query.bid || commonDsl.value?.bid || '',
      accountId:
        query.accountId || commonDsl.value?.accountId || '',
      eventType,
      channel: query.channel || commonDsl.value?.channel || '',
      markId:
        process.env.NODE_ENV === 'development'
          ? `${
              query.accountId || commonDsl.value?.accountId || ''
            }|${new Date().getTime()}|${query['mark_id']}`
          : query['mark_id'] || '',
      host: window.location.host,
    }
    await store.dispatch('fetchWeiboMediaReturn', params)
  }

  const mediaReturn = (eventType) => {
    const channel = commonDsl.value?.channel
    if (channel.indexOf('UC') !== -1) {
      // uc渠道
      ucChannel(eventType)
    } else if (channel.indexOf('BAI_DU') !== -1) {
      // 百度渠道
      baiduChannel(eventType)
    } else if (channel.indexOf('TENG_XUN') !== -1) {
      // 腾讯渠道（广点通回传 + MP回传）
      if (channel.indexOf('MP') !== -1) wxChannel(eventType)
      else if (channel.indexOf('GDT') !== -1) gdtChannel(eventType)
    } else if (channel.indexOf('BYTE_DANCE') !== -1) {
      // 头条渠道
      toutiaoChannel(eventType)
    } else if (channel.indexOf('360_PC') !== -1) {
      // 360PC渠道
      pc360Channel(eventType)
    } else if (channel.indexOf('QUICK_HAND') !== -1) {
      // 快手渠道
      kuaishouChannel(eventType)
    } else if (channel.indexOf('WB_H5') !== -1) {
      weiboChannel(eventType)
    }
  }
  return {
    addFriendFront,
    mediaReturn,
  }
}

export default useMediaReturn
